export function resolveContentId(content, { parentId, collection, index } = {}) {
    const existingId = content?.id || content?._id || content?.content_id || content?.report_id || content?.survey_id || content?.program_id || content?.user_id
    if (existingId) return String(existingId)
    if (parentId !== undefined && parentId !== null && collection && Number.isInteger(index) && index >= 0) {
        return `${parentId}:${collection}:${index}`
    }
    return undefined
}

export function contentLabel(content) {
    return content?.title || content?.name || content?.content_name || content?.full_name || [content?.first_name, content?.last_name].filter(Boolean).join(' ') || undefined
}

export function trackedSurfaceIdentity(eventName, contentId, content) {
    return `${eventName}:${contentId ?? content ?? ''}`
}
